import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance30 = () => {
  return <IndividualTable matchType={"8"} gender="M" event="30" subTitle="Zamby" data={sampleData} topRankCount="4" winners={["297", "428", "312", "328"]} />;
};
export default Distance30;
